/* tslint:disable */

declare var Object: any;
export interface TrmmreimtypeInterface {
  "reimCode": string;
  "companyCode": string;
  "reimnameEn"?: string;
  "reimnameId"?: string;
  "reimnameMy"?: string;
  "reimnameTh"?: string;
  "currencyCode"?: string;
  "parentFlag"?: string;
  "groupCode"?: string;
  "groupReimbalance"?: string;
  "reimBalance"?: string;
  "groupClaimlimit"?: string;
  "claimLimit"?: string;
  "approvedreceipt"?: number;
  "defaultPeriod"?: string;
  "availableAfter"?: number;
  "interfacePayroll"?: string;
  "warningBalance"?: number;
  "onceclaim"?: string;
  "reimburseforfam"?: string;
  "dependentlimittype"?: string;
  "repeatflag"?: string;
  "repeatperiod"?: number;
  "repeatbasedon"?: string;
  "repeatdate"?: Date;
  "validateclaim"?: string;
  "proportional"?: number;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy"?: string;
  "modifiedDate"?: Date;
  "requestDaylimit"?: number;
  "graceforactive"?: number;
  "enableMinus"?: string;
  "allowExceed"?: string;
  "enableReprocessBal"?: string;
}

export class Trmmreimtype implements TrmmreimtypeInterface {
  "reimCode": string;
  "companyCode": string;
  "reimnameEn": string;
  "reimnameId": string;
  "reimnameMy": string;
  "reimnameTh": string;
  "currencyCode": string;
  "parentFlag": string;
  "groupCode": string;
  "groupReimbalance": string;
  "reimBalance": string;
  "groupClaimlimit": string;
  "claimLimit": string;
  "approvedreceipt": number;
  "defaultPeriod": string;
  "availableAfter": number;
  "interfacePayroll": string;
  "warningBalance": number;
  "onceclaim": string;
  "reimburseforfam": string;
  "dependentlimittype": string;
  "repeatflag": string;
  "repeatperiod": number;
  "repeatbasedon": string;
  "repeatdate": Date;
  "validateclaim": string;
  "proportional": number;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy": string;
  "modifiedDate": Date;
  "requestDaylimit": number;
  "graceforactive": number;
  "enableMinus": string;
  "allowExceed": string;
  "enableReprocessBal": string;
  constructor(data?: TrmmreimtypeInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Trmmreimtype`.
   */
  public static getModelName() {
    return "Trmmreimtype";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Trmmreimtype for dynamic purposes.
  **/
  public static factory(data: TrmmreimtypeInterface): Trmmreimtype{
    return new Trmmreimtype(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Trmmreimtype',
      plural: 'Trmmreimtypes',
      path: 'Trmmreimtypes',
      properties: {
        "reimCode": {
          name: 'reimCode',
          type: 'string'
        },
        "companyCode": {
          name: 'companyCode',
          type: 'string'
        },
        "reimnameEn": {
          name: 'reimnameEn',
          type: 'string'
        },
        "reimnameId": {
          name: 'reimnameId',
          type: 'string'
        },
        "reimnameMy": {
          name: 'reimnameMy',
          type: 'string'
        },
        "reimnameTh": {
          name: 'reimnameTh',
          type: 'string'
        },
        "currencyCode": {
          name: 'currencyCode',
          type: 'string'
        },
        "parentFlag": {
          name: 'parentFlag',
          type: 'string'
        },
        "groupCode": {
          name: 'groupCode',
          type: 'string'
        },
        "groupReimbalance": {
          name: 'groupReimbalance',
          type: 'string'
        },
        "reimBalance": {
          name: 'reimBalance',
          type: 'string'
        },
        "groupClaimlimit": {
          name: 'groupClaimlimit',
          type: 'string'
        },
        "claimLimit": {
          name: 'claimLimit',
          type: 'string'
        },
        "approvedreceipt": {
          name: 'approvedreceipt',
          type: 'number'
        },
        "defaultPeriod": {
          name: 'defaultPeriod',
          type: 'string'
        },
        "availableAfter": {
          name: 'availableAfter',
          type: 'number'
        },
        "interfacePayroll": {
          name: 'interfacePayroll',
          type: 'string'
        },
        "warningBalance": {
          name: 'warningBalance',
          type: 'number'
        },
        "onceclaim": {
          name: 'onceclaim',
          type: 'string'
        },
        "reimburseforfam": {
          name: 'reimburseforfam',
          type: 'string'
        },
        "dependentlimittype": {
          name: 'dependentlimittype',
          type: 'string'
        },
        "repeatflag": {
          name: 'repeatflag',
          type: 'string'
        },
        "repeatperiod": {
          name: 'repeatperiod',
          type: 'number'
        },
        "repeatbasedon": {
          name: 'repeatbasedon',
          type: 'string'
        },
        "repeatdate": {
          name: 'repeatdate',
          type: 'Date'
        },
        "validateclaim": {
          name: 'validateclaim',
          type: 'string'
        },
        "proportional": {
          name: 'proportional',
          type: 'number'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "createdDate": {
          name: 'createdDate',
          type: 'Date'
        },
        "modifiedBy": {
          name: 'modifiedBy',
          type: 'string'
        },
        "modifiedDate": {
          name: 'modifiedDate',
          type: 'Date'
        },
        "requestDaylimit": {
          name: 'requestDaylimit',
          type: 'number'
        },
        "graceforactive": {
          name: 'graceforactive',
          type: 'number'
        },
        "enableMinus": {
          name: 'enableMinus',
          type: 'string'
        },
        "allowExceed": {
          name: 'allowExceed',
          type: 'string'
        },
        "enableReprocessBal": {
          name: 'enableReprocessBal',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Trmmreimtype.ts